module.exports = __webpack_public_path__ + "img/consultoria_9-16_1080.02b03003.jpg";